export default __webpack_public_path__ + "static/media/7.c9affb8e.png";